import React from 'react';
import { Quote } from '@naf/quote';
import { QuoteType } from '@appTypes/blockTypes';
import { useCloudinary } from '@hooks/Cloudinary/useCloudinary';

interface QuoteSerializerProps {
  value: QuoteType;
}

export const QuoteBlock = ({ value: { text, author, authorImage, link } }: QuoteSerializerProps) => {
  const { getProcessedImage } = useCloudinary();
  return authorImage ? (
    <Quote
      caption={author}
      img={{
        alt: authorImage.source_altText ? authorImage.source_altText : 'forfatterbilde',
        src: getProcessedImage(authorImage?.publicId || authorImage?.public_id, { width: 96, height: 96 })?.toURL(),
      }}
      href={link}
    >
      {text}
    </Quote>
  ) : (
    <Quote caption={author} href={link}>
      {text}
    </Quote>
  );
};
